export const AIR_AMBULANCE_BUTTON = 'air-ambulance-button';
export const CALL_OUT_TO_TAB = 'call-out-to-tab';
export const FLOOR_SELECTOR = 'floor-selector';
export const EAGLE_EYE_VIDEO = 'eagle-eye-video';
export const SUPPORTED_CUSTOM_COMPONENTS = [
  AIR_AMBULANCE_BUTTON,
  CALL_OUT_TO_TAB,
  FLOOR_SELECTOR,
  EAGLE_EYE_VIDEO,
];
